// ═══════════════════════════════════════════════════════════════
// UTILIDAD: Manejo de URLs de imágenes
// Genera URLs correctas para imágenes según el entorno
// ═══════════════════════════════════════════════════════════════

// En desarrollo: REACT_APP_API_URL=http://localhost:5000/api → base = http://localhost:5000
// En producción: REACT_APP_API_URL=/api → base = '' (nginx sirve /uploads desde el mismo dominio)
const getBackendBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  return apiUrl.replace(/\/api$/, '');
};

/**
 * Obtiene la URL completa de una imagen
 * @param {string} imageUrl - Ruta de la imagen (ej: /uploads/employees/foto.jpg)
 * @returns {string} URL completa de la imagen
 */
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return null;

  // Si ya es una URL completa (http:// o https://) o base64, devolverla tal cual
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('data:')) {
    return imageUrl;
  }

  // Rutas relativas: prefijar con el base URL del backend
  // En local: http://localhost:5000/uploads/...
  // En producción: /uploads/... (nginx lo resuelve)
  return `${getBackendBaseUrl()}${imageUrl}`;
};

/**
 * Obtiene la URL de la foto de un empleado
 * @param {string} foto - Ruta de la foto del empleado
 * @returns {string|null} URL de la foto o null
 */
export const getEmployeePhotoUrl = (foto) => {
  return getImageUrl(foto);
};

/**
 * Obtiene la URL del logo de una compañía
 * @param {string} logo - Ruta del logo de la compañía
 * @returns {string|null} URL del logo o null
 */
export const getCompanyLogoUrl = (logo) => {
  return getImageUrl(logo);
};

/**
 * Obtiene la URL de un documento
 * @param {string} documentUrl - Ruta del documento
 * @returns {string|null} URL del documento o null
 */
export const getDocumentUrl = (documentUrl) => {
  return getImageUrl(documentUrl);
};

export default {
  getImageUrl,
  getEmployeePhotoUrl,
  getCompanyLogoUrl,
  getDocumentUrl
};
